var exports = {
  "gt": "hiddenAvatar__ClJpDE",
  "RU": "hiddenNotice__Mp9zx8",
  "Wy": "unhideLabel__az-IOW",
  "zQ": "unhideIcon__diNgdA",
  "s$": "approvedStatus__y5LsA7",
  "uo": "changesRequestedStatus__qwZEAK",
  "sR": "dismissedStatus__0UWQ9Z",
  "ZC": "commentedStatus__LfU-Bn",
  "bS": "statusBackground__hotYAX",
};

module.exports = exports;
